//#region Imports
import { createFeature, createReducer, on } from '@ngrx/store';
import { EmptyAddress } from 'clicklease-ui-elements';
import {
    LoadPersonalInfoFormAction,
    ResetPersonalInfoFormAction,
    ResetPersonalInfoFormAddressAction,
    ResetPersonalInfoFormFirstNameAction,
    ResetPersonalInfoFormLastNameAction,
    ResetPersonalInfoFormPhoneAction,
    ResetPersonalInfoFormEmailAction,
    ResetSubmittingPersonalInfoFormAction,
    SetPersonalInfoFormAction,
    SetPersonalInfoFormFirstNameAction,
    SetPersonalInfoFormLastNameAction,
    SetPersonalInfoFormPhoneAction,
    SetPersonalInfoFormEmailAction,
    SetPersonalInfoFormAddressAction,
    SetSubmittingPersonalInfoFormAction,
    SetSubmittingPersonalInfoFormErrorAction,
    SetPersonalInfoFormMarketingOptInAction,
    ResetPersonalInfoFormMarketingOptInAction,
} from './personal-info-form.actions';
import { PersonalInformationFormState } from './../../interfaces';

//#region State consts

const initialState: PersonalInformationFormState = {
    isSubmitting: false,
    isSubmittingError: false,
    loading: false,
    data: {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        address: EmptyAddress(),
        marketingOptIn: undefined,
    },
};

export const PersonalInfoFormFeatureName = 'PersonalInfoForm';

//#region Feature

export const PersonalInfoFormFeature = createFeature({
    name: PersonalInfoFormFeatureName,
    reducer: createReducer(
        initialState,
        on(LoadPersonalInfoFormAction, (state) => ({
            ...state,
            loading: true,
            isSubmitting: false,
            isSubmittingError: false,
        })),
        on(ResetPersonalInfoFormAction, (state) => initialState),
        on(ResetPersonalInfoFormAddressAction, (state) => ({
            ...state,
            data: { ...state.data, address: EmptyAddress() },
        })),
        on(ResetPersonalInfoFormFirstNameAction, (state) => ({
            ...state,
            data: { ...state.data, firstName: initialState.data.firstName },
        })),
        on(ResetPersonalInfoFormLastNameAction, (state) => ({
            ...state,
            data: { ...state.data, lastName: initialState.data.lastName },
        })),
        on(ResetPersonalInfoFormPhoneAction, (state) => ({
            ...state,
            data: { ...state.data, phone: initialState.data.phone },
        })),
        on(ResetPersonalInfoFormEmailAction, (state) => ({
            ...state,
            data: { ...state.data, email: initialState.data.email },
        })),
        on(ResetSubmittingPersonalInfoFormAction, (state) => ({
            ...state,
            isSubmitting: false,
        })),
        on(
            SetPersonalInfoFormAction,
            (state, { firstName, lastName, email, phone, address }) => ({
                ...state,
                data: {
                    firstName,
                    lastName,
                    phone,
                    email,
                    address,
                },
            })
        ),
        on(SetPersonalInfoFormFirstNameAction, (state, { firstName }) => ({
            ...state,
            data: { ...state.data, firstName },
        })),
        on(SetPersonalInfoFormLastNameAction, (state, { lastName }) => ({
            ...state,
            data: { ...state.data, lastName },
        })),
        on(SetPersonalInfoFormPhoneAction, (state, { phone }) => ({
            ...state,
            data: { ...state.data, phone },
        })),
        on(SetPersonalInfoFormEmailAction, (state, { email }) => ({
            ...state,
            data: { ...state.data, email },
        })),
        on(SetPersonalInfoFormAddressAction, (state, { address }) => ({
            ...state,
            data: { ...state.data, address },
        })),
        on(SetSubmittingPersonalInfoFormAction, (state) => ({
            ...state,
            isSubmitting: true,
            loading: false
        })),
        on(SetSubmittingPersonalInfoFormErrorAction, (state) => ({
            ...state,
            isSubmittingError: true,
            loading: false
        })),
        on(SetPersonalInfoFormMarketingOptInAction, (state, { marketingOptIn }) => ({
            ...state,
            data: { ...state.data, marketingOptIn },
        })),
        on(ResetPersonalInfoFormMarketingOptInAction, (state) => ({
            ...state,
            data: { ...state.data, marketingOptIn: undefined },
        }))
    ),
});
